/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useAuth0 } from "@auth0/auth0-react";
import {
  Box,
  FlexContainer,
  Heading,
  Spacer,
  SVGIcon,
  Text,
  theme,
} from "@nordcloud/gnui";
import { ExternalLink } from "~/components";
import { Mailto } from "~/components/Utils";

export function Page403() {
  const { user } = useAuth0();

  return (
    <Box spacing="spacing04" padding={theme.spacing.spacing07}>
      <FlexContainer direction="column" justifyContent="center">
        <SVGIcon name="padlock" size="xxl" />
        <Spacer height={theme.spacing.spacing07} />
        <Heading level={1} mb={0} as="p">
          You need permission to access this service
        </Heading>
        <Text align="center">
          You are signed as {user?.email}, but you don&apos;t have permission to
          access this service. You can request access from{" "}
          <Mailto email="products@nordcloudapp.com" /> by clicking the button
          below.
        </Text>
        <Spacer height={theme.spacing.spacing07} />
        <ExternalLink href="https://nordcloud.atlassian.net/servicedesk/customer/portal/90">
          Request access
        </ExternalLink>
      </FlexContainer>
    </Box>
  );
}
